import { actionCreatorFactory } from 'typescript-fsa';
import { INode } from '@cbridge-packages/node';
import { IStream } from '@cbridge-packages/stream';

export namespace StreamsFilterAction {
  const actionCreator = actionCreatorFactory('StreamsFilter');

  export const select = actionCreator<{ streamId: IStream['streamId'] }>('SELECT');
  export const toggleSelect = actionCreator<{ streamId: IStream['streamId'] }>('TOGGLE_SELECT');
  export const clearSelect = actionCreator('CLEAR_SELECT');

  export const destroy = actionCreator('DESTROY');
}

export namespace NodeStreamsFilterAction {
  const actionCreator = actionCreatorFactory('NodeStreamsFilter');

  export const toggleSelectStream = actionCreator<{ streamId: IStream['streamId'] }>('TOGGLE_SELECT_STREAM');
  export const toggleSelectNode = actionCreator<{ nodeId: INode['nodeId'] }>('TOGGLE_SELECT_NODE');
  export const clearSelect = actionCreator('CLEAR_SELECT');

  export const destroy = actionCreator('DESTROY');
}
